(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.innerHeader = this.header ? this.header.querySelector('.header') : null;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.scrollDeltaTolerance = 8;
      this.menuHidden = false;
      this.toggleCooldown = 150;
      this.lastToggleAt = 0;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this), { passive: true });
      window.addEventListener('load', this.setHeaderHeight.bind(this));
      if (document && document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.setHeaderHeight());
      }
      try {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        if (this.header) this.resizeObserver.observe(this.header);
        const annEl = document.querySelector('.announcement-bar-section .utility-bar');
        if (annEl) {
          this.announcementResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
          this.announcementResizeObserver.observe(annEl);
        }
      } catch(e) {}

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      const ann = document.querySelector('.announcement-bar-section .utility-bar');
      const annHeight = ann ? ann.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-height', `${annHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      try {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.announcementResizeObserver) this.announcementResizeObserver.disconnect();
      } catch(e) {}
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const delta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const now = Date.now();
      if (now - this.lastToggleAt < this.toggleCooldown) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      if (Math.abs(delta) < this.scrollDeltaTolerance) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (delta > 0) {
          if (this.preventHide) {
            this.currentScrollTop = scrollTop;
            return;
          }
          requestAnimationFrame(this.hide.bind(this));
        } else {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.menuHidden) return;
      if (this.innerHeader) this.innerHeader.classList.add('menu-hidden');
      this.menuHidden = true;
      this.lastToggleAt = Date.now();
      this.header.classList.add('shopify-section-header-sticky');
      this.setHeaderHeight();

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.menuHidden) return;
      if (this.innerHeader) this.innerHeader.classList.remove('menu-hidden');
      this.menuHidden = false;
      this.lastToggleAt = Date.now();
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.setHeaderHeight();
    }

    reset() {
      if (this.innerHeader) this.innerHeader.classList.remove('menu-hidden');
      this.menuHidden = false;
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
      this.setHeaderHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      (this.disclosures || []).forEach(disclosure => {
        if (disclosure && typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
